<template>
  <LeftSide>
    <template v-slot:title>
      Create Nomination
    </template>

    <div class="mt-2">
      <div class="bg-grey-blue p-3 rounded">
        <FormulateForm name="formulateForm"
                       @created="resetFormValues"
                       @submit="handleSubmitForm"
                       v-model="formValues"
                       :errors="formErrors">
          <ifac-nomination-form :award="award" :schema="formSchema"/>
        </FormulateForm>
      </div>

      <div class="row submit-buttons">
        <div class="col-md-3 p-0">
          <button
            type="submit"
            class="btn btn-light p-0"
            @click="cancelCreate"
          >
            Cancel Nomination
          </button>
        </div>
        <div class="col text-right right-col p-0">
          <button
            type="submit"
            class="btn btn-primary"
            @click="submitForm"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </LeftSide>
</template>

<script>
import nominationsMixin from '@/mixins/awards/nominations.mixin';
import LeftSide from '@/views/areas/awards/LeftSide.vue';
import { IfacNominationForm } from '@ifac/ui';

export default {
  mixins: [nominationsMixin],
  components: { LeftSide, IfacNominationForm },
  props: {
    award: {
      type: Object,
      required: true,
    },
  },
  name: 'NominationsCreate',
  created() {
    this.$store.dispatch('awards/setCurrentAward', this.award);

    const form = this.award?.forms?.filter((form) => form.type === 'nomination')[0] ?? null;
    this.formSchema = form.schema;
    this.formValues = {
      co_nominated: [],
      referees: [
        {
          emails: [],
        },
      ],
    };
  },
  data() {
    return {
      formSchema: [],
      formValues: {},
      formErrors: {},
      scrollbarHeight: 0,
    };
  },
  methods: {
    cancelCreate() {
      this.$router.push({ name: 'Nominations' });
    },
    resetFormValues() {
      this.formValues.co_nominated.splice(0, 1);
      this.formValues.referees[0].emails.splice(0, 1);
    },
    submitForm() {
      this.$formulate.submit('formulateForm');
    },
    handleSubmitForm(data) {
      this.mx_createNomination(this.award, data);
    },
  },
};
</script>

<style scoped lang='scss'>
@import '@/assets/styles/base/_variables.scss';
@import '@/assets/styles/base/_mixins.scss';
</style>
